// "Smith" -> "Smith", "Jane Doe" -> "Jane". Used for "Meet Jane at ...".
export const getCoachFirstName = coach =>
  coach?.name?.trim().split(/\s+/)[0] || 'Your coach'

const titleCase = value =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : value

// "Paid with Visa ending in 4242", or null when Stripe gave no card details.
export const getPaidNote = ({ cardBrand, last4 } = {}) =>
  last4
    ? `Paid with ${titleCase(cardBrand) || 'card'} ending in ${last4}`
    : null

export const getDurationInMinutes = (startDateTime, endDateTime) =>
  startDateTime && endDateTime
    ? Math.round((new Date(endDateTime) - new Date(startDateTime)) / 60000)
    : 0

// Maps the `Enrollment` the paid return page loads (see `./query.js`) to the
// props of `PrivateLessonConfirmation`.
export const enrollmentToConfirmationProps = enrollment => {
  const { lesson, transactions, student } = enrollment || {}
  const { coach, coachFacility, title, startDateTime, endDateTime } =
    lesson || {}
  const { amountInCents, registrationPayment } = transactions?.[0] || {}
  const studentName = [student?.firstName, student?.lastName]
    .filter(Boolean)
    .join(' ')

  return {
    coach,
    lessonTitle: title,
    durationInMinutes: getDurationInMinutes(startDateTime, endDateTime),
    facility: coachFacility,
    startDateTime,
    studentName,
    email: student?.contact?.email,
    payment: {
      amountInCents,
      cardBrand: registrationPayment?.cardBrand,
      last4: registrationPayment?.last4,
    },
  }
}

// The facility the lesson was booked at, else the lesson type's first one.
export const pickFacility = (facilities, locationId) =>
  facilities?.find(({ id }) => String(id) === String(locationId)) ||
  facilities?.[0]

// Where the confirmation email went: the guest's contact email, the student's
// own address when a coach booked for them, else the signed-in user's.
export const getBookingEmail = ({
  student,
  guest,
  user,
  coachBooksOnBehalfOfStudent,
}) => {
  if (guest) return guest.contact?.email
  if (coachBooksOnBehalfOfStudent) {
    return student?.representatives?.find(r => r?.relationshipType === 'SELF')
      ?.contact?.email
  }
  return user?.email
}
